/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrevoApiValidationV1Dto } from '../models/BrevoApiValidationV1Dto';
import type { BrevoCreateSmtpEmailV1Dto } from '../models/BrevoCreateSmtpEmailV1Dto';
import type { BrevoSendFreeTextPostPayloadV1Dto } from '../models/BrevoSendFreeTextPostPayloadV1Dto';
import type { BrevoSendTemplatePostPayloadV1Dto } from '../models/BrevoSendTemplatePostPayloadV1Dto';
import type { BrevoSmtpTemplateDetailV1Dto } from '../models/BrevoSmtpTemplateDetailV1Dto';
import type { BrevoSmtpTemplateOverviewV1 } from '../models/BrevoSmtpTemplateOverviewV1';
import type { CreateExternalApiKeyV1Dto } from '../models/CreateExternalApiKeyV1Dto';
import type { ExternalApiKeyV1Dto } from '../models/ExternalApiKeyV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrevoService {
  /**
   * @param requestBody
   * @returns ExternalApiKeyV1Dto create entity
   * @throws ApiError
   */
  public static brevoControllerV1CreateApiKeyV1(
    requestBody: CreateExternalApiKeyV1Dto,
  ): CancelablePromise<ExternalApiKeyV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/brevo/apikey',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ExternalApiKeyV1Dto the entity
   * @throws ApiError
   */
  public static brevoControllerV1FindLatestKeysV1(): CancelablePromise<ExternalApiKeyV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/brevo/apikey',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id
   * @returns ExternalApiKeyV1Dto the entity
   * @throws ApiError
   */
  public static brevoControllerV1DeleteApiKeyV1(
    id: string,
  ): CancelablePromise<ExternalApiKeyV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/brevo/apikey/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id
   * @returns ExternalApiKeyV1Dto the entity
   * @throws ApiError
   */
  public static brevoControllerV1FindOneApiKeyV1(
    id: string,
  ): CancelablePromise<ExternalApiKeyV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/brevo/apikey/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id
   * @returns BrevoApiValidationV1Dto the entity
   * @throws ApiError
   */
  public static brevoControllerV1ValidateApiKeyV1(
    id: string,
  ): CancelablePromise<BrevoApiValidationV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/brevo/apikey/validate/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param bypassCache
   * @returns BrevoSmtpTemplateOverviewV1 a entity list
   * @throws ApiError
   */
  public static brevoControllerV1FindallTemplatesV1(
    bypassCache: boolean,
  ): CancelablePromise<Array<BrevoSmtpTemplateOverviewV1>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/brevo/templates',
      query: {
        bypassCache: bypassCache,
      },
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param bypassCache
   * @param id
   * @returns BrevoSmtpTemplateDetailV1Dto the entity
   * @throws ApiError
   */
  public static brevoControllerV1FindOneTemplateV1(
    bypassCache: boolean,
    id: string,
  ): CancelablePromise<BrevoSmtpTemplateDetailV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/brevo/templates/{id}',
      path: {
        id: id,
      },
      query: {
        bypassCache: bypassCache,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns BrevoCreateSmtpEmailV1Dto create entity
   * @throws ApiError
   */
  public static brevoControllerV1SendFreeTextEmailV1(
    requestBody: BrevoSendFreeTextPostPayloadV1Dto,
  ): CancelablePromise<BrevoCreateSmtpEmailV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/brevo/send/free-text',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns BrevoCreateSmtpEmailV1Dto create entity
   * @throws ApiError
   */
  public static brevoControllerV1SendTemplateEmailV1(
    requestBody: BrevoSendTemplatePostPayloadV1Dto,
  ): CancelablePromise<BrevoCreateSmtpEmailV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/brevo/send/template',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
}
